// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2_egr","boxTitle":"Qualiphy_boxTitle__24t18","box":"Qualiphy_box__2c71o","toggleWrap":"Qualiphy_toggleWrap__2VPSt"};